export const SET_DMD_LIST = "SET_DMD_LIST";
export const SET_DMD_TASK_LIST = "SET_DMD_TASK_LIST";
export const SET_DMD_STAGE_HISTORY = "SET_DMD_STAGE_HISTORY";
export const SET_DMD = "SET_DMD";
export const SET_DMD_STAGES_LIST = "SET_DMD_STAGES_LIST";
export const SET_DMD_TYPE_LIST = "SET_DMD_TYPE_LIST";
export const SET_DMD_SERVICE_CATEGORY_LIST = "SET_DMD_SERVICE_CATEGORY_LIST";
export const SET_DMD_COMMENTS = "SET_DMD_COMMENTS";
export const SET_DMD_QUOTE_INVOICE = "SET_DMD_QUOTE_INVOICE";
export const SET_DMD_DELIVERABLES_LIST = "SET_DMD_DELIVERABLES_LIST";
export const SET_DMD_DELIVERABLES = "SET_DMD_DELIVERABLES";
export const SET_STAGEWISE_COUNT = "SET_STAGEWISE_COUNT";
export const SET_STATUSWISE_COUNT = "SET_STATUSWISE_COUNT";
export const SET_TASK_LIST = "SET_TASK_LIST";
export const SET_TASK_DELIVERABLES = "SET_TASK_DELIVERABLES";
export const SET_COMMENTS_BY_ID = "SET_COMMENTS_BY_ID";
export const SET_DMD_STATUS_LIST = "SET_DMD_STATUS_LIST";
export const CLEAR_DMD = "CLEAR_DMD";
export const SET_DEMAND_BY_DMDID = "SET_DEMAND_BY_DMDID";
export const SET_DMD_ORDER_LIST = "SET_DMD_ORDER_LIST";
export const SET_INVOICE_REQUEST_LIST = "SET_INVOICE_REQUEST_LIST";
export const SET_DMD_DELIVERY_PENDING_LIST = "SET_DMD_DELIVERY_PENDING_LIST";
export const SET_DMD_DELIVERABLES_BY_TYPE = "SET_DMD_DELIVERABLES_BY_TYPE";
export const SET_DEMAND_SUMMARY = "SET_DEMAND_SUMMARY";